<style lang="less">
    .pagebar-context {
        min-width: 166px;
    }
</style>
<i18n>
{
  "zh": {
    "SaveAsPage": "将该页另存为",
    "renamePage": "重命名页面",
    "dupPage": "复制页面",
    "dupPageBack": "复制页面背景",
    "delPage": "删除页面",
    "pageRecoder": "重排序页面"
  },
  "en": {
    "SaveAsPage": "Save This Page As",
    "renamePage": "Rename Page",
    "dupPage": "Duplicate Page",
    "dupPageBack": "Duplicate Page Background",
    "delPage": "Delete Page",
    "pageRecoder": "Rearrange Page "
  },
  "fr": {
    "SaveAsPage": "Enregistrer cette page sous",
    "renamePage": "Renommer la page",
    "dupPage": "Dupliquer la page",
    "dupPageBack": "Dupliquer le fond de page",
    "delPage": "Supprimer la page",
    "pageRecoder": "Réorganiser la page"
  },
  "de": {
    "SaveAsPage": "Diese Seite speichern unter",
    "renamePage": "Seite umebnennen ",
    "dupPage": "Seite kopieren ",
    "dupPageBack": "Seitehintergrund kopieren ",
    "delPage": "Seite löschen",
    "pageRecoder": "Seite Recodierung"
  },
  "jp": {
    "SaveAsPage": "このページに名前を付けて保存",
    "renamePage": "ページ名を変更",
    "dupPage": "ページをコピー",
    "dupPageBack": "ページ背景をコピー",
    "delPage": "ページを削除",
    "pageRecoder": "ページ順を変更"
  },
  "es": {
    "SaveAsPage": "Guardar esta página como",
    "renamePage": "Renombrar página",
    "dupPage": "Página duplicada",
    "dupPageBack": "Fondo de página duplicado",
    "delPage": "Borrar página",
    "pageRecoder": "Reorganizar página"
  },
  "pt": {
    "SaveAsPage": "Salvar esta página como",
    "renamePage": "Renomear Página",
    "dupPage": "Duplicar Página",
    "dupPageBack": "Duplicar Fundo de Página",
    "delPage": "Eliminar Página",
    "pageRecoder": "Reorganizar Página"
  },
  "it": {
    "SaveAsPage": "Salva questa pagina con nome",
    "renamePage": "Rinomina Pagina",
    "dupPage": "Duplica Pagina",
    "dupPageBack": "Duplica Sfondo Pagina",
    "delPage": "Elimina Pagina",
    "pageRecoder": "Riordina Pagine"
  },
  "id": {
    "SaveAsPage": "Simpan halaman ini sebagai"
  },
  "kr": {
    "SaveAsPage": "이 페이지를 다른 이름으로 저장"
  },
  "tw": {
    "SaveAsPage": "將此頁另存為",
    "renamePage": "重命名頁面",
    "dupPage": "複製頁面",
    "dupPageBack": "複製頁面背景",
    "delPage": "刪除頁面",
    "pageRecoder": "重排序頁面"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import checkCloudSpaceLimit from "@/app/utils/checkCloudSpaceLimit.js";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class pageBarContext extends Vue {
        get menuList() {
            let list = [
                { key: "renamePage" },
                { key: "dupPage" },
                { key: "dupPageBack" },
                { key: "delPage", disabled: this.pagesLen === 1 },
                { key: "SaveAsPage" },
                { key: "pageRecoder", disabled: this.pagesLen === 1 },
            ];

            if (window.EDCONFIG.IS_SDK) {
                list = list.filter((item) => item.key !== "SaveAsPage");
            }

            let resultList = [];
            list.map((item) => {
                resultList.push(Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "pagebar-context", list: resultList };
        }
        get activedPageIndex() {
            return this.$store.state.page.activedPageIndex;
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "renamePage",
                    () => {
                        event.stopPropagation();
                        this.Rename();
                    },
                ],
                [
                    "dupPage",
                    () => {
                        event.stopPropagation();
                        this.Duplicate();
                    },
                ],
                [
                    "dupPageBack",
                    () => {
                        event.stopPropagation();
                        this.DuplicateBack();
                    },
                ],
                [
                    "delPage",
                    () => {
                        event.stopPropagation();
                        this.Delete();
                    },
                ],
                [
                    "SaveAsPage",
                    () => {
                        event.stopPropagation();
                        this.saveAs();
                    },
                ],
                [
                    "pageRecoder",
                    () => {
                        event.stopPropagation();
                        this.showPageRecoder();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        saveAs() {
            if (checkCloudSpaceLimit(this)) return;
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "saveAs",
            });
            this.$store.commit("setPageStat", {
                type: "isSaveSpecPage",
                data: true,
            });
            this.close();
        }
        close() {
            this.$store.commit("closeContext");
        }
        Rename() {
            this.$store.commit("setStatus", {
                type: "editingIndex",
                data: this.currentOpePageIndex,
            });
            this.close();
        }
        Delete() {
            let view = window["_view"];
            if (!view) return;
            if (this.pagesLen === 1) {
                return;
            }
            view.removePage(this.currentOpePageIndex);
            this.close();
        }
        Duplicate() {
            let view = window["_view"];
            if (!view) return;
            // if (!this.$checkAuth({ type: "addPage" })) return;
            if (!this.vip && this.pagesLen >= 2 && window.EDCONFIG.IS_SDK) {
                if (!this.$checkAuth({ type: "addPage", buyTrigger: "pagePop" })) return;
            }
            view.duplicatePage();
            if (!this.vip && this.$store.state.page.pages && this.pagesLen >= 2) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "pageIcon",
                });
            }
            this.$bus.$emit("refreshPagePre");
            this.close();
        }
        DuplicateBack() {
            let view = window["_view"];
            if (!view) return;
            // if (!this.$checkAuth({ type: "addPage" })) return;
            if (!this.vip && this.pagesLen >= 2 && window.EDCONFIG.IS_SDK) {
                if (!this.$checkAuth({ type: "addPage", buyTrigger: "pagePop" })) return;
            }
            view.duplicatePageBkgnd();
            if (!this.vip && this.$store.state.page.pages && this.pagesLen >= 2) {
                this.sensors.track("tryVipBenefit", {
                    Catalogues: "editFileProcess",
                    trial_vip_benefit: "pageIcon",
                });
            }
            this.$bus.$emit("refreshPagePre");
            this.close();
        }
        showPageRecoder() {
            if (this.pagesLen === 1) {
                return;
            }
            this.close();
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "pageReorder",
            });
        }

        get currentOpePageIndex() {
            return this.$store.state.ui.currentOpePageIndex;
        }
        get pagesLen() {
            return this.$store.state.page.pages.length;
        }

        mounted() {}
        created() {}
    }
</script>
